import React from 'react'

interface IButtonContainerProps {
  className?: string
  children: React.ReactNode
}

const ButtonContainer = ({ className, children }: IButtonContainerProps): React.ReactElement => (
  <div className={className}>{children}</div>
)
ButtonContainer.displayName = 'ButtonContainer'

export default ButtonContainer
